export function getExtension(filename: string): string {
	const split = filename.split('.');

	return split.length > 1 ? (split.pop()?.toLowerCase() ?? '') : '';
}

export enum FileTypes {
	Image,
	Doc,
	Pdf,
	Video,
	Xslx,
	Unknown,
}

export function resolveFileType(str: string): FileTypes {
	const result = getFileType(str);
	if (result !== FileTypes.Unknown) return result;

	return getFileTypeFromName(str);
}

export function getFileType(str: string): FileTypes {
	if (
		str.includes('image') ||
		str.includes('png') ||
		str.includes('jpg') ||
		str.includes('gif') ||
		str.includes('webp') ||
		str.includes('jpeg') ||
		str.includes('tiff')
	) {
		return FileTypes.Image;
	}

	if (str.includes('doc') || str.includes('docx')) {
		return FileTypes.Doc;
	}

	if (str.includes('video') || str.includes('mp4') || str.includes('mov')) {
		return FileTypes.Video;
	}

	if (str.includes('pdf')) {
		return FileTypes.Pdf;
	}

	if (str.includes('xlsx')) {
		return FileTypes.Xslx;
	}

	return FileTypes.Unknown;
}

export function getFileTypeFromName(fileName: string): FileTypes {
	const extension = getExtension(fileName);

	if (
		extension === 'png' ||
		extension === 'jpg' ||
		extension === 'gif' ||
		extension === 'webp' ||
		extension === 'jpeg' ||
		extension === 'tiff'
	) {
		return FileTypes.Image;
	}

	if (extension === 'doc' || extension === 'docx') {
		return FileTypes.Doc;
	}

	// Using the "video" check on the filename is maybe a legacy thing that Red Robin uses?
	if (extension === 'mp4' || extension === 'mov' || fileName.includes('video')) {
		return FileTypes.Video;
	}

	if (extension === 'pdf') {
		return FileTypes.Pdf;
	}

	if (extension === 'xlsx') {
		return FileTypes.Xslx;
	}

	return FileTypes.Unknown;
}
